import * as React from "react"
import type { SVGProps } from "react"
const SvgCloseCircleFilledMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.5 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14m-1.92-3.7L8.5 9.37l1.9 1.93q.27.3.69.3.4 0 .71-.3a1 1 0 0 0 .28-.7 1 1 0 0 0-.28-.7L9.87 7.96l1.93-1.9a1 1 0 0 0 .3-.68q0-.42-.3-.72a1 1 0 0 0-.7-.27 1 1 0 0 0-.7.27L8.5 6.6 6.58 4.68a1 1 0 0 0-.7-.28 1 1 0 0 0-.7.27 1 1 0 0 0-.28.7q0 .45.27.71l1.93 1.9L5.18 9.9a1 1 0 0 0-.28.7q0 .43.27.7a1 1 0 0 0 .7.27q.45 0 .71-.27"
    />
  </svg>
)
export default SvgCloseCircleFilledMini
